import {
    Badge,
    classNames,
    CodeDigits0,
    KeyPad,
    layout,
    PushButton,
    TextInput,
    theme,
    typography,
    useTypeRef,
    View
} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback, useState} from "react";
import {stylesheet} from "typestyle";
import {background} from "./background";
import {AccessStatus} from "./booking";
import {useLocalization} from "../../i18n";

interface BookingCodeViewProps {
    bookingCodeAccessStatus: AccessStatus;
    onBookingCode: (bookingCode: string) => void;
    onCancel: () => void;
    className?: string;
}

export function BookingCodeView(props: BookingCodeViewProps) {
    const {
        bookingCodeAccessStatus,
        onBookingCode,
        onCancel,
        className,
    } = props;

    const [bookingCode, setBookingCode] = useState("");
    const [type, setType] = useTypeRef();
    const {t} = useLocalization();

    const handleBookingCodeSubmit = useCallback(() => onBookingCode(bookingCode), [onBookingCode, bookingCode]);

    return (
        <View className={classNames(background, layout.vertical, layout.center, layout.alignCenter, styles.view, className)}>
            <div className={classNames(layout.horizontal)}>
                <div className={classNames(theme.moreContrast)}>
                    <TextInput
                        type={"password"}
                        onChange={setBookingCode}
                        value={bookingCode}
                        typeRef={setType}
                        disabled={bookingCodeAccessStatus == AccessStatus.Pending}
                        className={classNames(styles.textInput)}
                    />
                    <KeyPad onType={type} digits={CodeDigits0}
                            disabled={bookingCodeAccessStatus == AccessStatus.Pending}/>
                </div>
                <div
                    className={classNames(theme.lessContrast, layout.vertical, layout.spaceBetween, styles.boxLeft)}>
                    <div className={typography.title}>
                        {t("EnterBookingCode")}
                    </div>

                    <div>
                        {bookingCodeAccessStatus == AccessStatus.Pending && (
                            <p>{t("BookingCodeChecking")}</p>
                        )}
                        {bookingCodeAccessStatus == AccessStatus.Failed && (
                            <p>
                                <Badge error>
                                    {t("BookingCodeInvalid")}
                                </Badge>
                            </p>
                        )}
                    </div>

                    <div>
                        <PushButton primary className={classNames(styles.button, styles.marginBottom)}
                                    onClick={handleBookingCodeSubmit}>
                            {t("Submit")}
                        </PushButton>

                        <PushButton className={styles.button} onClick={onCancel}>
                            {t("Cancel")}
                        </PushButton>
                    </div>
                </div>
            </div>
        </View>
    )
}

const styles = stylesheet({
    view: {
        position: "relative",
    },
    textInput: {
        fontWeight: "bold",
        width: "28rem",
        height: "5rem",
    },
    button: {
        width: "100%",
    },
    marginBottom: {
        marginBottom: "1.5em",
    },
    boxLeft: {
        width: "20em",
        padding: "1.5em"
    },
    cardStatus: {
        width: "38em"
    },
    cardCancelContainer: {
        marginTop: "1.5em",
    }
});
